import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { User, PhoneNumber, ValidarPassword } from '../../utilidades/utilidades';
import { environment } from '../../../environments/environment.prod';
import { FuncionService } from '../../servicios/funcion.service';

import { isPlatformBrowser, isPlatformServer } from '@angular/common';

import * as $ from 'jquery';

const regex = /^[a-zA-ZÑñÁáÉéÍíÓóÚú\s]+$/;

@Component({
	selector: 'app-registro',
	templateUrl: './registro.component.html',
	styleUrls: ['./registro.component.css']
})
export class RegistroComponent implements OnInit {

	step:number = 1;
	phoneNumber = new PhoneNumber();
	newCuenta:any = {
		nombre:"",
		paterno:"",
		materno:"",
		username:"",
		telefono:"",
		password:"",
		confirmar:""
	};
	showPassword:boolean = false;
	showConfirmar:boolean = false;

	constructor(
		private newFuncionService:FuncionService,
		private newRouter:Router,
		private newTitle: Title,
		@Inject(PLATFORM_ID) private platformId: Object
	){

	}

	ngOnInit() {
		this.newTitle.setTitle("Registro de cuenta");
		if (isPlatformBrowser(this.platformId)){
			setTimeout( ()=>{
				$(".telInput").attr({"placeholder":"Teléfono (222 123 4567)"})
			},100);
		}
	}

	fnValidarNombreApellido(value:string, tipo:string = ''){
		if (value.trim().length > 0){
			if (!regex.test(value)){
				if(tipo === 'nombre'){
					this.newFuncionService.setNewAlerta(environment.alerta.registro.soloLetrasNombre)
				}else if(tipo === 'paterno'){
					this.newFuncionService.setNewAlerta(environment.alerta.registro.soloLetrasPaterno)
				}else if(tipo === 'materno'){
					this.newFuncionService.setNewAlerta(environment.alerta.registro.soloLetrasMaterno)
				}
				else{
					this.newFuncionService.setNewAlerta(environment.alerta.registro.soloLetras)
				}
			}
		}
	}

	fnValidarDatos() {
		if( this.newCuenta.nombre === "" || this.newCuenta.nombre.replace(/\s+/g, "").length === 0){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.nombre );
		}else if(!regex.test(this.newCuenta.nombre)){
			this.newFuncionService.setNewAlerta(environment.alerta.registro.soloLetras)
		}else if( this.newCuenta.paterno === "" || this.newCuenta.nombre.replace(/\s+/g, "").length === 0 ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.paterno );
		}else if(!regex.test(this.newCuenta.paterno)){
			this.newFuncionService.setNewAlerta(environment.alerta.registro.soloLetras)
		}else if(!regex.test(this.newCuenta.materno)){
			this.newFuncionService.setNewAlerta(environment.alerta.registro.soloLetras)
		}else if( this.newCuenta.username === "" ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.correo.vacio );
		}
		else if( !environment.validacion.correo.test( this.newCuenta.username ) ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.correo.formato );
		}else if( this.newCuenta.telefono === "" ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.telefono.vacio );
		}else{
			this.step = 2;
		}
	}

	fnRegistrarCuenta(){
		if( this.newCuenta.password === "" ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.password );
		}else if( this.newCuenta.confirmar === "" ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.confirmar );
		}else if( this.newCuenta.password !== this.newCuenta.confirmar ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.match );
		}else if(!ValidarPassword (this.newCuenta.password)){
			this.newFuncionService.setNewAlerta(environment.alerta.registro.contraseñaSegura)
		}
		
		else{
			var newCliente = this.newCuenta;
			this.newFuncionService.setNewMensaje("Registrando nueva cuenta...");
			this.newFuncionService.fnRegistrarCuenta( { cliente:this.newCuenta, carrito:{uuid:this.newFuncionService.currentUuidValue} } )
		.subscribe( (response:any) => {
			this.newFuncionService.setNewMensaje(null);
			if( response.success ){
			this.newFuncionService.setNewAlerta(environment.alerta.registro.success);
			this.newRouter.navigate([ 'acceso' ]);
			}else{
			if( response.code === 0 ){
				this.newFuncionService.setNewAlerta( environment.alerta.registro.find );
			}else{
				this.newFuncionService.setNewAlerta( environment.alerta.registro.fail );
			}
			this.step = 1;
			}
		});
	}
  }	

  	telInputObject(obj) {
		obj.setCountry('mx');
	}

	hasError( newEvent ){
		if( !newEvent ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.telefono.formato );
		}
	}

	getNumber( newEvent ){
		this.newCuenta.telefono = newEvent;
	}

	onCountryChange( newEvent ){ }

	fnAcccionPassword( opcion ){
		if( opcion === 1 ){
			this.showPassword = !this.showPassword;
		}else{
			this.showConfirmar = !this.showConfirmar;
		}
	}




	fnCambiarPaso(){
		this.step = 1;		
	}

}





